module.exports = __webpack_public_path__ + "img/price.2067ee34.svg";